export const CHANGE_FULLSCREEN = 'changeFullscreenApp';
export const SET_URL_PARAMS = 'setUrlParamsApp';
export const GET_TOUR_PENDING = 'getTourAppPending';
export const GET_TOUR_FULFILLED = 'getTourAppFulfilled';
export const GET_TOUR_REJECTED = 'getTourAppRejected';
export const SET_CONTENT_BLUR = 'setContentBlurApp';

export const SAVE_POSITION = 'savePositionApp';
export const CLEAR_POSITION = 'clearPositionApp';
export const TOGGLE_FULLSCREEN = 'toggleFulscreenApp';

export const POST_MESSAGE_EVENT = 'postMessageEvent'